import { createApiClient, type ApiClient } from "@crucible/api-client";
import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useTenant } from "@/app/providers/TenantProvider";

const ApiCtx = createContext<ApiClient | null>(null);

export function ApiProvider({ children }: { children: ReactNode }) {
  const { orgSlug } = useTenant();
  const client = useMemo(
    () =>
      createApiClient({
        baseUrl: import.meta.env.VITE_API_URL || "",
        orgSlug,
      }),
    [orgSlug],
  );

  return <ApiCtx.Provider value={client}>{children}</ApiCtx.Provider>;
}

export function useApi() {
  const ctx = useContext(ApiCtx);
  if (!ctx) throw new Error("useApi must be used within ApiProvider");
  return ctx;
}